import {combineReducers} from "redux";
import {createStore, applyMiddleware, compose} from 'redux';
import {createLogger} from 'redux-logger';

import application from '../application.reducer'
import sample from '../modules/sample/sample.reducer'
import record from '../modules/record/record.reducer'
import periods from '../modules/periods/period.reducer';
import irrs from '../modules/irr/irr.reducer';
import irrSample from '../modules/irr-sample/irr-sample.reducer';

import thunk from 'redux-thunk';
import * as schema from './schema';

const rootReducer = combineReducers({
  application,
  periods,
  sample,
  record,
  irrs,
  irrSample
});


const middleware = [thunk.withExtraArgument({schema})];
// if (process.env.REACT_APP_LOG_REDUX) {
//   middleware.push(createLogger())
// }

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore() {
  return createStore(
    rootReducer,
    composeEnhancers(
      applyMiddleware(...middleware)
    )
  );
}



// WEBPACK FOOTER //
// ./src/store/index.js